import { IOption } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectSortType } from '../../selectors/filters';
import { SORTING_OPTIONS } from '../../constants/sorting';
import { TSortType } from '../../types/filters';

export function useSelectedSortOption() {
  const sortType = useSelector(selectSortType);

  return React.useMemo(() => {
    return SORTING_OPTIONS.find(({ value }) => value === sortType) as IOption<TSortType>;
  }, [sortType]);
}
